import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Routable::ExternalhitRoute />",{ moduleName: "mewe/templates/externalhit.hbs" })